module.exports = __webpack_public_path__ + "p8_img3.jpg?4c2a1bbce87e2c9abf9c3266e24b1b32";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p8/p8_img3.jpg
// module id = 134
// module chunks = 0